export const Styles = () => ({
  colorPickerWrapper: {
    alignSelf: "center",
    marginLeft: props => props.xs ? 5 : 20,
    marginTop: props => props.xs ? 10 : 0,
    position: "relative"
  },
});
